import { type GetMetricsQueryParams } from '@gonfalon/openapi/operations/getMetrics';

import { createQueryHook } from '../internal/createQueryHook';
import { metrics } from '../queries/metrics';

/**
 * @deprecated Use `metrics.list()` with `useQuery` directly.
 */
export const useMetrics = createQueryHook(
  ({ projectKey, params }: { projectKey: string; params?: GetMetricsQueryParams }) =>
    metrics.list({ projectKey, params }),
);
